/// <reference types="@yandex-int/error-counter/dist/implementation.d.ts" />

import { isFunction } from '@direct-frontend/stdlib';
import { isRumDebugEnabled } from './isRumDebugEnabled';
import { mergeAdditional, removeOldAdditional } from './mergeAdditional';
import { type TDict } from './types';

/**
 * Отправляет событие в events.
 * @see https://events.chv.yandex-team.ru/projects/yastore-b2b
 * @see https://events.chv.yandex-team.ru/projects/yastore-b2c
 * @see https://events.chv.yandex-team.ru/projects/yastore-checkout
 */
export function logEvent(type: string, name: string, value: string | number, additional: TDict = {}) {
    const isRumAvailable = isFunction(window.Ya?.Rum?.send);

    const vars: TDict = {
        '-type': type,
        '-name': name,
        '-value': value,
        '-referrer': window.location.href,
        '-ts': Date.now(),
    };

    if (isRumDebugEnabled()) {
        console.warn(`📊 RUM event${isRumAvailable ? '' : ' (dry-run)'}`, vars, additional);
    }

    if (!isRumAvailable) {
        return;
    }

    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- Используется для совместимости с API window.Ya.Rum.send
    const never = null as never;

    /**
     * Отправляем событие по аналогии с @yandex-int/error-counter
     * https://a.yandex-team.ru/arcadia/velocity/error-booster/error-counter/src/logEvent.js?rev=r10523886#L61
     */
    return window.Ya.Rum.send(
        never,
        '690.32', // tech/event
        stringifyVars(vars, additional),
        never,
        never,
        never,
        ['table=rum_events']
    );
}

function stringifyVars(vars: TDict, additional: TDict) {
    const full = window.Ya.Rum.getVarsList?.() || [];

    /**
     * Уже могут быть переменные в -additional, которые нужно сохранить
     * Поэтому объединяем существующие с новыми переменными
     */
    if (Object.keys(additional).length > 0) {
        vars['-additional'] = mergeAdditional(full, additional);
        removeOldAdditional(full);
    }

    for (const key in vars) {
        const val = vars[key];

        if (vars.hasOwnProperty(key) && (val || val === 0)) {
            // Функция encodeURIComponent не кодирует звёздочку
            full.push(key + '=' + encodeURIComponent(val).replace(/\*/g, '%2A'));
        }
    }

    return full.join(',');
}
